import { combineReducers } from 'redux';

import customFields from './customFields.reducer';
import priceConcession from './priceConcession.reducer';

const reducer = {
  pricing: combineReducers({
    priceConcession,
    customFields,
  }),
};

export default reducer;
